import { Routes, Route, Navigate } from 'react-router-dom';
import ReportsContainer from './pages/ReportsContainer';
import OrderDetail from './pages/OrderDetail';
import OrdersReport from './pages/OrdersReport';
import UniUniShipmentsReport from './pages/UniUniShipmentsReport';
import Reports from './pages/Reports';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminDashboard from './pages/AdminDashboard';
import PickupAddress from './pages/PickupAddress';
import ExportReport from './pages/ExportReport';
import ProductsReport from './pages/ProductsReport';
import InventoryManagement from './pages/InventoryManagement';
import InventoryReconciliation from './pages/InventoryReconciliation';
import AppLayout from './components/AppLayout';
import GuestLayout from './components/GuestLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './context/AuthContext';

function RootRedirect() {
  const { isAdmin, isAuthenticated, isLoading } = useAuth();
  if (isLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <Navigate to={isAdmin ? '/admin' : '/orders'} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route element={<GuestLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/reset" element={<ResetPassword />} />
      </Route>
      <Route element={<AppLayout />}>
        <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>} />
        <Route path="/" element={<RootRedirect />} />
        <Route path="/orders" element={<ProtectedRoute><OrdersReport /></ProtectedRoute>} />
        <Route path="/shipping" element={<ProtectedRoute><ReportsContainer /></ProtectedRoute>} />
        {/* Regular operators need this to print labels + monitor shipments. */}
        <Route path="/uniuni-shipments" element={<ProtectedRoute><UniUniShipmentsReport /></ProtectedRoute>} />
        <Route path="/order/:orderId" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
        <Route path="/pickup-addresses" element={<ProtectedRoute requireAdmin><PickupAddress /></ProtectedRoute>} />
        <Route path="/return" element={<ProtectedRoute><ReportsContainer /></ProtectedRoute>} />
        <Route path="/export" element={<ProtectedRoute requireAdmin><ExportReport /></ProtectedRoute>} />
        <Route path="/products" element={<ProtectedRoute><ProductsReport /></ProtectedRoute>} />
        <Route path="/inventory" element={<ProtectedRoute><InventoryManagement /></ProtectedRoute>} />
        <Route path="/inventory-recon" element={<ProtectedRoute requireAdmin><InventoryReconciliation /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute requirePermission="reports:read"><Reports /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
}
